import React, { useCallback, useEffect, useState } from "react";
import Information from "../../common/information";
import { useDispatch, useSelector } from "react-redux";
import {
  editLegality,
  getLegality,
} from "../../redux/services/informationSlice";
import { toast } from "react-toastify";

const Legality = () => {
  const dispatch = useDispatch();
  const [editorContent, setEditorContent] = useState("");
    const [selectedType, setSelectedType] = useState("course");
  
  const illegalityData = useSelector((state) => state?.information?.legality);

  const handleEditorChange = (newContent) => {
    setEditorContent(newContent);
  };
  const getIllegalityData = useCallback(async (type) => {
    try {
      await dispatch(getLegality(type));
    } catch (error) {}
  }, [dispatch]);
  useEffect(() => {
    getIllegalityData(selectedType);
  }, [getIllegalityData ,selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        editLegality({ illegality: editorContent , type: selectedType })
      );
      if (response) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getIllegalityData(selectedType);
      }
    } catch (error) {
    }
  };
  useEffect(() => {
    if (illegalityData) {
      setEditorContent(illegalityData?.illegality);
    }
  }, [illegalityData]);
  // const handleExportPDF = () => {
  //   generatePDF(editorContent, "Legality.pdf");
  // };
  return (
    <>
      <Information
        title="Legality"
        handleSubmit={handleSubmit}
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // handleExportPDF={handleExportPDF}
      />
    </>
  );
};

export default Legality;
